import {doStyleProductsListing} from "../blocks/productsListing";
import {doStyleSidebarFilters} from "../blocks/sidebar-filters";
import {TranslationsManager} from "../utils/localisationManager";

export class CategoryPage {
    static EventListeners = {
       'ShoptetDOMPageContentLoaded': CategoryPage.doInit,
        'ShoptetDOMPageMoreProductsLoaded': CategoryPage.doLoadOnShoptetDOMPageMoreProductsLoaded,
    }
    // static doLoadOnShoptetDOMPageContentLoaded() {}
    static doLoadOnShoptetDOMPageMoreProductsLoaded() {
        doStyleProductsListing();
    }
    // static doLoadOnShoptetDOMContentLoaded() {}
    // static doLoadOnChange() {}
    static async doInit() {
        CategoryPage.doStyleMisc()
        doStyleProductsListing()
        doStyleSidebarFilters()
        return true;
    }

    static doStyleMisc() {
        $('.category-perex').insertAfter('.category-title');
        // $('main#content h4:contains("Nejprodávanější")').addClass('hidden');
        $('.subcategories li').removeClass('col-lg-3 col-xl-3');
        $('.category-header div').appendTo('.pagination-wrapper .pagination-top');
        $('.pagination-loader span').text(`${TranslationsManager.doGetStringByLang('MORE_ITEMS_BTN')}`);
    }
}
